import React from "react";

export default function SQLServer_SQRT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_SQRT</h1>
      <p>This is the SQLServer_SQRT component generated from the SQL JSON.</p>
    </div>
  );
}
